import axios from "axios";
import { useEffect, useState } from "react";
import { Button } from "./DanitComponents/Buttons/Button";
import InputWithLabel from "./DanitComponents/Inputs/InputWithLabel";
import { PasswordReset } from "./PasswordReset/PasswordReset";
import { baseUrl } from "./assets/Animations";
import LoginBgTeacher from "./static/img/login-background-teacher.jpg";
import { displayVersionNumber } from "./utilityFunctions";

const Login = ({ accessPoint, onLoggedIn }) => {
  const [schoolInfo, setSchoolInfo] = useState({
    abbreviation: "",
    schoolAbb: "",
    schoolName: "",
  });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showReset, setShowReset] = useState(false);

  useEffect(() => {
    let url = window.location.href;
    let trimmed = url.substring(8);
    let name = trimmed.split(".")[0];
    if (name === "mountainside") {
      setSchoolInfo({
        abbreviation: "MMA",
        schoolAbb: "MMA",
        schoolName: "Mountainside",
        logoUrl: "https://www.mountainsidemusicacademy.com/logo.png",
      });
    } else if (name === "lakeside") {
      setSchoolInfo({
        abbreviation: "LSMA",
        schoolAbb: "LSMA",
        schoolName: "Lakeside",
        logoUrl: "https://www.lakesidemusicacademy.com/logo.png",
      });
    } else if (name === "treeside") {
      setSchoolInfo({
        abbreviation: "TSMA",
        schoolAbb: "TMA",
        schoolName: "Treeside",
        logoUrl: "https://www.treesidemusicacademy.com/logo.png",
      });
    } else if (name === "morningside") {
      setSchoolInfo({
        abbreviation: "MMA",
        schoolAbb: "MMA",
        schoolName: "Morningside",
        logoUrl: "https://www.morningsidemusicacademy.com/logo.png",
      });
    } else if (name === "parkside") {
      setSchoolInfo({
        abbreviation: "PSMA",
        schoolAbb: "PSMA",
        schoolName: "Parkside",
        logoUrl: "https://www.parksidemusicacademy.com/logo.png",
      });
    } else if (name === "denton") {
      setSchoolInfo({
        abbreviation: "DEN",
        schoolAbb: "DEN",
        schoolName: "Denton",
        logoUrl: "https://www.atharomusic.com/denton-logo__dark.png",
      });
    } else if (name === "tempe") {
      setSchoolInfo({
        abbreviation: "TEM",
        schoolAbb: "TEM",
        schoolName: "Tempe",
        logoUrl: "https://www.atharomusic.com/tempe-logo__dark.png",
      });
    } else if (name === "tulsa") {
      setSchoolInfo({
        abbreviation: "TUL",
        schoolAbb: "TUL",
        schoolName: "Tulsa",
        logoUrl: "https://www.atharomusic.com/tulsa-logo__dark.png",
      });
    }
  }, []);

  const adminSubmit = async () => {
    axios
      .post(`${baseUrl}/login`, {
        Email: email,
        Password: password,
      })
      .then((response) => {
        if (response.data.user.School === "admin") {
          onLoggedIn(response.data);
        } else {
          alert("Access not granted");
        }
      })
      .catch((e) => {
        console.log(e);
        alert("Incorrect Username or Password. Please try again...");
      });
  };

  const teacherSubmit = async () => {
    let preparedEmail = email;
    preparedEmail = preparedEmail.toLowerCase().trim();
    axios
      .post(`${baseUrl}/login`, {
        Email: preparedEmail,
        Password: password,
      })
      .then((response) => {
        onLoggedIn(response.data);
      })
      .catch((e) => {
        console.log("no such user " + e);
        console.log(e);
        alert("Incorrect Username or Password. Please try again...");
      });
  };

  const toggleReset = () => {
    setShowReset(!showReset);
  };

  const resetPass = () => {
            let theEmail = email
        if(theEmail === '') {
            alert('Please enter your email address.')
            return
        }
        if(!theEmail.includes('@')) {
            alert('Please enter a valid email address.')
            return  
        }
        if(!theEmail.includes('.')) {
            alert('Please enter a valid email address.')
            return
        }
        axios.put(`${baseUrl}/fullpassreset`, {
            Email: theEmail,
        })
        .then(response => {
            if(response.status === 200) {
                alert('Your password has been reset. Please check your email.')
                setShowReset(false);
                setEmail("");
                setPassword("");
            } else {
                alert('Sorry! There seems to be a problem. Please send us an email and we will reset your password.')
            }
        })
.catch(e => {
    if (e.response && e.response.status === 404) {
        alert(e.response.data.message); // <-- Your custom message from server
    } else {
        alert('Sorry! There seems to be a problem. Please send us an email and we will reset your password.');
    }

    console.log(e.response?.data || e.message);
})
  }

  const isAdmin = accessPoint === "admin";
  const title = isAdmin ? "Admin Portal" : (showReset ? "Reset Password" : "Teacher Portal");
  const bgImage = isAdmin
    ? "./login-background.jpg"
    : schoolInfo.schoolAbb
    ? `./${schoolInfo.schoolAbb}.jpg`
    : LoginBgTeacher;

  const onSubmit = () => {
    if (isAdmin) adminSubmit();
    else teacherSubmit();
  };

  return (
    <div
      className="w-screen h-screen flex items-center justify-center bg-cover"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700 m-5">
        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
          <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
            {title}
          </h1>
          {/* <PasswordReset resetOpen={showReset} schoolName={schoolInfo.schoolName} toggleReset={toggleReset} /> */}
          <div className="space-y-4 md:space-y-6" action="#">
            {showReset && <div className="text-slate-600">Enter the email you use for the teacher portal, and we’ll send you a temporary password.</div>}
            <InputWithLabel label="Email" name="email" type="email" placeholder="something@company.com" onChange={(value) => setEmail(value)} value={email} />
            {!showReset && <InputWithLabel label="Password" name="password" type="password" placeholder="Password" onChange={(value) => setPassword(value)} value={password} />}
            <div className="flex items-center justify-end">
              {!isAdmin && !showReset && (
                <button
                  className="bg-transparent text-blue-700 hover:text-blue-300 font-semibold py-2 px-4 border border-transparent small text-sm"
                  onClick={() => toggleReset()}
                >
                  Forgot my password
                </button>
              )}
            </div>
            <Button color={showReset ? "warning" : "primary"} text={showReset ? "Send Password" : "Log in"} action={showReset ? resetPass : onSubmit} size="lg" fullWidth />
            { showReset && 
            <div className="flex items-center">
              <div className="inline-block m-auto text-orange-700 font-extrabold underline" onClick={() => {setShowReset(false); setEmail(""); setPassword("");}}>Back</div>
            </div>}
            <div className="flex items-center justify-center mt-4">
              <div className="text-slate-400 text-xs -mb-7 font-extrabold">{displayVersionNumber()}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
